export const options = [
    { 
      value: true,
      label: "Active"
    },
    {
      value:  false,
      label: "Terminated"
    }
  ];